import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-session-data-dialog-box',
  templateUrl: './session-data-dialog-box.component.html',
  styleUrls: ['./session-data-dialog-box.component.scss']
})
export class SessionDataDialogBoxComponent implements OnInit {
  displayedColumns = ['Session Number', 'Session Year', 'Session Code', 'Session Name', 'Session Default', 'Session Status'];
  SessionForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  isread = false;
  showSubmitButton = true;
  isreadonly = false;
  sessionList: any;
  session: string;
  list;
  sessionform: any;
  SessionSearchForm;
  SessionList: any;
  filteredListSession: any;
  codeTypeList: any;
  filteredCodeType: any;
  isShowDiv=false;
  dialogRef: MatDialogRef<any>;
  desLabel: any;
  currentsession: string;
  userPermission:any;
  utp: any;
  sessCreate = true;
sessUpdate = true;
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef2: MatDialogRef<SessionDataDialogBoxComponent>,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner:NgxSpinnerService) {
  }
  download(){
    const wwe = ['SnNo', 'SnYear', 'SnCode', 'SnName', 'SnDefault', 'SnStatus'];
    this.umsService.downloadFile(this.SessionList, 'jsontocsv', wwe);
  }
  MenuCode = 'new';
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Session' && element.PCreate == false)
      {
          this.sessCreate = false;  
      }
      if(element.PageName == 'Session' && element.PUpdate == false)
      {
          this.sessUpdate = false;  
      }   
      // if(element.PageName == 'State' && element.PDelete == false)
      // {
      //     this.sessDelete = false;  
      // } 
    });
  }
    window.scroll(0, 0);
    this.route.queryParams.subscribe(
      params => {
        this.MenuCode = params['MenuCode'];
        if(this.MenuCode == "switch-session"){
          this.submitButton = false;
        }
      }
    )
  
    this.submitButton = true;
    this.editButton = false;
    let id = '';
    this.fetchCodeType(id);
    this.getSessionData();
    this.list = true;
    this.SessionForm = this.fb.group({
      SnNo: new FormControl(''),
      SnYear: new FormControl('', [Validators.required, Validators.pattern(/^([0-9]{4})(-[0-9]{4})?$/)]),
      SnCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      SnName: new FormControl(''),
      SnDefault: new FormControl('Y', [Validators.required, ]),
      SnStatus: new FormControl('O')
    });
    this.SessionSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    if(this.MenuCode == "switch-session"){
      this.submitButton = false;
    }
    if(this.data.key == "Edit") { 
      this.prepopulation(this.data.selected);
    } 
    // else if (this.data.key == "Delete") {
    //  this.DeletePrepopulation(this.data.selected);
    // } else {
    //   // alert(this.data.key)  
    // }
  } 

  selectedTeam = '';
	onSelected(value:string): void {
		this.selectedTeam = value;
	}


  keypress() {
    this.umsService.searchSession(this.SessionSearchForm.value).subscribe(res => {
      this.sessionList = res.data;
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
    });
  }

  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = res.data;
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }
  sessionSort(e) {
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = e.EmId;
    this.umsService.getSession(payload).subscribe(res => {
      this.SessionList = res.data;
    });
  }

  prepopulation(id) {
    const payload = {};
    payload['SnNo'] = id.SnNo;
    this.umsService.getSession(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.submitButton = false;
        this.editButton = true;
        this.isreadonly = true;
        this.isread = true;
        this.isShowDiv=true;
        let payload2 = data.SnName +"," +data.SnYear;
        this.SessionForm = this.fb.group({
          SnNo: new FormControl(data.SnNo,),
          SnYear: new FormControl(data.SnYear, [Validators.required, Validators.pattern('^[1-2][0-9][0-9][0-9]*$'), Validators.min(1800), Validators.max(2100)]),
          SnCode: new FormControl(data.SnCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          SnName: new FormControl(data.SnName),
          SnDefault: new FormControl(data.SnDefault, [Validators.required, ]),
          SnStatus: new FormControl(data.SnStatus)
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },(ERROR: HttpErrorResponse) => {
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  submit() {
    if (this.SessionForm.invalid) {
      this.SessionForm.get('SnNo').markAsTouched();
      this.SessionForm.get('SnYear').markAsTouched();
      this.SessionForm.get('SnCode').markAsTouched();
      this.SessionForm.get('SnDefault').markAsTouched();
      this.SessionForm.get('SnStatus').markAsTouched();
      return;
    } else {
      this.Session();
    }
  }

  Session() {
    this.spinner.show();
    let payload = this.SessionForm.value;
    this.umsService.addSession(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   let  data1 = {}
        //   data1['message'] = res.messagetwo
        //   data1['title'] = 'Information'
        //   data1['icon'] = 'fas fa-check'
        //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data1);
        //   });
        
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data); 
   });
  }

  update() {
    if (this.SessionForm.invalid) {
      this.SessionForm.get('SnNo').markAsTouched();
      this.SessionForm.get('SnYear').markAsTouched();
      this.SessionForm.get('SnDefault').markAsTouched();
      this.SessionForm.get('SnStatus').markAsTouched();
      return;
    } else {
      this.updateSession();
    }
  }

  updateSession() {
    this.spinner.show();
    this.submitpayload = this.SessionForm.value;
    if(this.submitpayload.SnStatus != 'C'){
      this.umsService.updateSession(this.submitpayload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        } else {
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       
     });
    }
    else{
      const payload = {};
      payload['SnNo'] = this.SessionForm.value.SnNo;
      this.umsService.closeSession(payload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        } 
        else {
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       
     });
    }
    
  }

  // addnewrecord(e) {
  //   if (e === 'true') {
  //     this.editButton= false;
  //     this.submitButton = true;
  //     this.list = false;
  //     this.isreadonly = false;
  //     this.isShowDiv=false;
  //      this.SessionForm.reset();
  //     this.SessionForm = this.fb.group({
  //       SnNo: new FormControl('',),
  //       SnYear: new FormControl('', [Validators.required, Validators.pattern('^[1-2][0-9][0-9][0-9]*$'), Validators.min(1800), Validators.max(2100)]),
  //       SnCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
  //       SnName: new FormControl(''),
  //       SnDefault: new FormControl('Y', [Validators.required,]),
  //       SnStatus: new FormControl('O')
  //     });
      
  //   } else {
  //     this.list = true;
  //     this.editButton= true;
  //     this.submitButton = false;
  //     this.isShowDiv=true;
  //     this.ngOnInit();
  //   }
  // }

  // editdata(e, k) {
  //   if (e === 'true') {
  //     let id = '';
  //     this.list = false;
  //     this.isreadonly = false;
  //     this.getSessionData(id);
  //     this.prepopulation(k);
  //   } else {
  //     this.list = true;
  //   }
  // }
  addnewrecord() { 
    const dialogRef = this.dialog.open(SessionDataDialogBoxComponent, {
      width: '35%',
      data: {key : "New"},
      disableClose: true  
    });  
    dialogRef.afterClosed().subscribe(result => {
      this.getSessionData();
    });
  }
  editData(k){
    const dialogRef = this.dialog.open(SessionDataDialogBoxComponent, {
      width: '35%',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
        this.getSessionData();
    });
  }
  deleteData(k){
    const dialogRef = this.dialog.open(SessionDataDialogBoxComponent, {
      width: '35%',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
        this.getSessionData();
    });
  }
  switchSession(k){
    let data = {};
    data['message'] = "Switch to " +k.SnName;
    data['title'] = 'Switch Session';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        sessionStorage.setItem("session",JSON.stringify(k));
      this.mysecret();
      }
    });
  }
  mysecret(){
    this.umsService.getsecreat('').subscribe(res => {
      this.currentsession = sessionStorage.getItem("session");
      if(this.currentsession == null){
        this.umsService.secret(res.projectPharam);
      }else{
        let data = JSON.parse(this.currentsession)
        res.projectPharam['SnCode'] = data['SnCode']
        res.projectPharam['SnDefault'] =  data['SnDefault']
        res.projectPharam['SnName'] =  data['SnName']
        res.projectPharam['SnNo'] =  data['SnNo']
        res.projectPharam['SnStatus'] =  data['SnStatus']
        res.projectPharam['SnYear'] =  data['SnYear']
        this.umsService.secret(res.projectPharam);
      }
      // if()
      // 
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  fetchCodeType(id) {
    const payload = {};
    payload['CdType'] = 'SN';
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  sessionName(name: string) {
    let payload = this.SessionForm.value;
    const year = payload.SnYear;
    const yearPattern = /^([0-9]{4})(-[0-9]{4})?$/;
    if (!yearPattern.test(year)) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        title: 'Invalid Format',
        message: 'Please enter session year',
        icon: 'fas fa-exclamation-triangle'
      });return; }
    if (year.includes('-')) {
const [startYear, endYear] = payload.SnYear.split('-').map(Number);
      if (startYear < 1800 || endYear > 2100 || endYear !== startYear + 1) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          title: 'Invalid Year Range',
          message: 'End year must be exactly one more than start year.',
          icon: 'fas fa-exclamation-triangle'
        });
        return;}} else {
      const startYear = Number(year);
    if(startYear < 1800 || startYear > 2100){
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          title: 'Invalid Year',
          message: 'Please enter a valid year between 1800 and 2100.',
          icon: 'fas fa-exclamation-triangle'
        });
        return;}}
      this.SessionForm.controls["SnName"].setValue(`${name}, ${payload.SnYear}`);
    }

    


  sessionName2(){
    let payload = this.SessionForm.value;
    let payload1 = {   
      CdType: 'SN',
    CdCode : payload.SnCode
  }
    const yearPattern = /^([0-9]{4})(-[0-9]{4})?$/;


    if (!yearPattern.test(payload.SnYear)) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        title: 'Invalid Format',
        message: 'Please enter session year in yyyy-yyyy format',
        icon: 'fas fa-exclamation-triangle'
      });
      return;

    }
    if (payload.SnYear.includes('-')) {
      const [startYear, endYear] = payload.SnYear.split('-').map(Number);
      if (endYear !== startYear + 1 || startYear < 1800 || endYear > 2100) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          title: 'Invalid Range',
          message: 'End year must be exactly one more than start year.',
          icon: 'fas fa-exclamation-triangle'
        });
        return;
      }
    }
    this.umsService.getCode(payload1).subscribe(res => {
      if (res.status && res.data.length>0) {
        const selectedCode = res.data.find(
          (item: any) => item.CdCode === payload.SnCode
        )
       if(selectedCode){
        this.SessionForm.controls["SnName"].setValue(`${selectedCode.CdDesc},${payload.SnYear}`);
      } else{
        this.SessionForm.controls["SnName"].setValue('');
      }
      }
    },(ERROR: HttpErrorResponse) => {
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    
  }

  codeTypeClick(value)
  {
   this.desLabel = value;
  }
}
